import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FaArrowUp, FaCheck, FaCopy } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import './Footer.css';
import logo from '../../../assets/images/logos/mcgp-logo.png';
import { formatWalletAddress } from '../../../utils';
import pitch from '../../../assets/pitch.pdf';
import whitepaper from '../../../assets/whitepaper.pdf';
import tokenization from '../../../assets/tokenization.pdf';

function Footer() {
  const [copiedState, setCopiedState] = useState({
    eth: false,
    bsc: false,
  });

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 500,
      smooth: 'easeInOutQuart',
    });
  };

  const copyToClipboard = (text, network) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedState({ ...copiedState, [network]: true });
      setTimeout(() => {
        setCopiedState({ ...copiedState, [network]: false });
      }, 2000);
    });
  };

  return (
    <footer className="site-footer">
      <div className="back-to-top">
        <Button className="scroll-top-btn" onClick={scrollToTop}>
          <FaArrowUp />
        </Button>
      </div>

      <Container>
        <div className="footer-content">
          <Row>
            <Col lg="4" md="6" sm="12" className="footer-section">
              <div className="footer-brand">
                <Link to="/" className="footer-logo">
                  <img src={logo} alt="MCGPChain Logo" />
                </Link>
                <p className="footer-description">
                  MCGPChain is your gateway to the future of digital
                  finance—secure, accessible, and built for real-world impact.
                </p>
              </div>
            </Col>

            <Col lg="2" md="6" sm="12" className="footer-section">
              <h4 className="footer-heading">Resources</h4>
              <ul className="footer-links">
                <li>
                  <Link to={whitepaper} target="_blank">Whitepaper</Link>
                </li>
                <li>
                  <Link to={tokenization} target="_blank">
                    Onchain Stable Asset Tokenization
                  </Link>
                </li>
                <li>
                  <Link to={pitch} target="_blank">Pitch Deck</Link>
                </li>
              </ul>
            </Col>

            <Col lg="3" md="6" sm="12" className="footer-section">
              <h4 className="footer-heading">Legal</h4>
              <div className="footer-disclaimer">
                <p>
                  This website is not a solicitation or recommendation to buy or
                  sell any token. Token transactions carry risk, and users are
                  responsible for losses and tax obligations.
                </p>
              </div>
            </Col>

            <Col lg="3" md="6" sm="12" className="footer-section">
              <h4 className="footer-heading">Partners</h4>
              <div className="partners-list">
                <p>TSA Connect | Blockchain Networking Pioneers</p>
                <p>Other partners will be updated soon!</p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="footer-contact">
          <div className="contact-section">
            <h4 className="contact-title">Feedback and Inquiries</h4>
            <p>
              You can email us at{' '}
              <a href="mailto:mcgpchain@gmail.com">
                mcgpchain@gmail.com
              </a>{' '}
              to provide feedback for support requests.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>©2025 MCGPchain. All rights reserved</p>
          </div>

          <div className="contract-addresses">
            <div className="contract-item">
              <span className="network">Sonic</span>
              <span className="address">{formatWalletAddress('0x517600323e5E2938207fA2e2e915B9D80e5B2b21')}</span>
              <button
                className="copy-btn"
                onClick={() => copyToClipboard('0x517600323e5E2938207fA2e2e915B9D80e5B2b21', 'eth')}
              >
                {copiedState.eth ? (
                  <>
                    <FaCheck /> Copied
                  </>
                ) : (
                  <>
                    <FaCopy /> Copy
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
